import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
import * as PIXI from 'pixi.js'
import { GAME_ORDER } from '../model/GameModel'
import gameState from '../model/GameModel'
import { setupClicker } from '../controller/ButtonController'

export class GameOverView extends koko.view {
    clickAllowed = false;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'shape', name: 'bg', x: -280, y: 0, width: 1326, height: 1355, fill: 0, alpha: 0.6},
            { type: 'sprite', id: 'carrier_big', name: 'bg2', x: vp.centerX, y: 678, width: 642, height: 1066, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'gameover_title', name: 'title', x: vp.centerX, y: 246, width: 268, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'You successfully decoded the secret message\nusing frequency analysis.', font: 'typrighter_small', size: 30, tint: 0, name: 'successText', align:'center', x: vp.centerX, y: 296, anchorX: 0.5, anchorY: 0},
            { type: 'sprite', id: 'rank_1star', name: 'rank', x: vp.centerX, y: 543, width: 358, height: 356, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'feedback_banner', name: 'feedback', x: vp.centerX, y: 767, width: 466, height: 114, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'previous_header', name: 'prevhead', x: vp.centerX, y: 870, width: 178, height: 38, anchorX: 0.5, anchorY: 0.5},

            { type: 'container', name: 'prev1', x: 355, y: 926},
                { type: 'bmptext', parent: 'prev1', text: 'PIGPEN', font: 'typrighter_small', size: 30, tint: 0, name: 'prev1text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r1', x: 126, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r2', x: 159, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev1', id: 'rank_empty', name: 'prev1r3', x: 191, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
            
            { type: 'container', name: 'prev2', x: 355, y: 960},
                { type: 'bmptext', parent: 'prev2', text: 'CAESAR CIPHER', font: 'typrighter_small', size: 30, tint: 0, name: 'prev2text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r1', x: 126, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r2', x: 159, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev2', id: 'rank_empty', name: 'prev2r3', x: 191, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},

            { type: 'container', name: 'prev3', x: 355, y: 994},
                { type: 'bmptext', parent: 'prev3', text: 'FREQUENCY ANALYSIS', font: 'typrighter_small', size: 30, tint: 0, name: 'prev3text', align:'left', x: -153, y: -13, anchorX: 0, anchorY: 0},
                { type: 'sprite', parent: 'prev3', id: 'rank_empty', name: 'prev3r1', x: 126, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev3', id: 'rank_empty', name: 'prev3r2', x: 159, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},
                { type: 'sprite', parent: 'prev3', id: 'rank_empty', name: 'prev3r3', x: 191, y: 0, width: 45, height: 44, anchorX: 0.5, anchorY: 0.5},

            { type: 'sprite', id: 'continue_btn', name: 'continue_btn', x: vp.centerX, y: 1090, width: 434, height: 105, anchorX: 0.5, anchorY: 0.5},
        ], this.container);

        // let scoresFound = false;
        for (let i = 0; i < GAME_ORDER.length; i++) {
            if (gameState.gameScores[i] > 0 /*&& gameState.currentGame > i*/) {
                // scoresFound = true;
                this.children['prev' + (i + 1)].visible = true;
                for (let j = 1; j <= gameState.gameScores[i]; j++) {
                    this.children['prev' + (i + 1) + 'r' + j].texture = PIXI.Texture.from('rank_full.png');
                }
            } // else {
                // this.children['prev' + (i + 1)].visible = false;
            // }
        }
        // if (!scoresFound) {
            // this.children.prevhead.visible = false;
        // }

        this.children.successText.text = GAME_ORDER[gameState.currentGame].successMessage;

        if (gameState.gameScores[gameState.currentGame] > 1) {
            this.children.rank.texture = PIXI.Texture.from('rank_' + gameState.gameScores[gameState.currentGame] + 'stars.png');
        }
        if (gameState.gameScores[gameState.currentGame] < 3) {
            this.children.feedback.texture = PIXI.Texture.from('feedback_banner_' + gameState.gameScores[gameState.currentGame] + 'stars.png');
        }

        this.resize();
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.width = vp.width + Math.abs(vp.x) * 4;
        bg.height = vp.height + Math.abs(vp.y) * 4;
        bg.x = vp.centerX - bg.width / 2;
        bg.y = vp.centerY - bg.height / 2;
        */
    }

    transitionIn = () => {
        // au.playRandom('pop', 1, 10);

        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35, onComplete: this.transitionInDone});

        // setTimeout(this.transitionOut, 3000);

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.continue_btn.interactive = true;
        this.children.continue_btn.on(event, this.nextGame);
        */
        this.clickAllowed = true;
    }

    transitionInDone = () => {
        setupClicker(this.children.continue_btn, this.nextGame);
    }

    transitionOut = () => {
        this.children.continue_btn.interactive = false;
        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    nextGame = (e) => {
        if (this.clickAllowed) {
            au.play('button', 1, false);
            this.transitionOut();
            gameState.nextGame();
            this.clickAllowed = false;
        }
    }
}